import $ from 'jquery';
import Templates from '../generated/tc/modules/templates';
import 'bootstrap-loading';

const loader = {
    showLoading(ele, options = {}) {
        $('body')
            .data('bs.loading', null)
            .loading({
                template: Templates.read('ha-loading')({
                    ...options,
                }),
                showHybridLoadingScreen: options.showHybridLoadingScreen,
                header: options.header,
            });

        $(ele).loading('show');
    },

    hideLoading(ele) {
        $(ele).loading('hide');
    },

    isLoading() {
        return (
            !!document.getElementsByClassName('ha-loading-overlay')?.length ||
            !!document.getElementsByClassName('mcko-loading-overlay')?.length
        );
    },
};

export default loader;
